// MondayDate.jsx

// Dependencies
import { Component } from 'react';

class MondayDate extends Component {
  constructor(props) {
    super(props);
    if (props instanceof MondayDate) {
      this.state = {
        date: new Date(props.state.date)
      };
    } else {
      this.state = {
        date: this.getMonday()
      };
    }
  }

  getMonday() {
    const today = new Date();
    const day = today.getDay();
    const diff = today.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(today.setDate(diff));
  }

  previousMonday() {
    const newDate = new Date(this.state.date);
    newDate.setDate(newDate.getDate() - 7);
    this.state.date = newDate;
  }

  nextMonday() {
    const newDate = new Date(this.state.date);
    newDate.setDate(newDate.getDate() + 7);
    this.state.date = newDate;
  }

  getSQLDate() {
    const day = String(this.state.date.getDate()).padStart(2, '0');
    const month = String(this.state.date.getMonth() + 1).padStart(2, '0');
    const year = this.state.date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  getUIDate() {
    const day = String(this.state.date.getDate()).padStart(2, '0');
    const month = String(this.state.date.getMonth() + 1).padStart(2, '0');
    const year = this.state.date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Rearrange the components into the "DD/MM/YYYY" format
  static formatToUIDate(dateString) {
    const [year, month, day] = dateString.split('-');
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  // Rearrange the components into the "YYYY-MM-DD" format
  static formatToSQLDate(dateString) {
    const [day, month, year] = dateString.split('/');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  render() {
    return null; // Class components must render something
  }
}

export default MondayDate;
